import { useStore } from 'effector-react'
import { YMInitializer } from 'react-yandex-metrika'
import { YANDEX_METRIKA_ACCOUNT } from '~/shared/config/env'
import { featureFlagModel } from '~/shared/lib/featureFlag'

export function InitYandexMetrika() {
  const featureFlags = useStore(featureFlagModel.$featureFlags)
  if (!featureFlags.yandex_metrika || !YANDEX_METRIKA_ACCOUNT) return null

  return (
    <YMInitializer
      accounts={[Number(YANDEX_METRIKA_ACCOUNT)]}
      options={{
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: featureFlags.yandex_metrika_webvisor,
      }}
    />
  )
}
